import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

const AdvancedSearchFormField = ({ input, label, disabled, placeholder, type, name, meta: { touched, error }, clang }) => {
    return (
        <div className={`advanced-search__field ${touched ? error : ''}`}>
            <label className="advanced-search__field-label" htmlFor={input.name}>
                {label}
                {label && <span>:</span>}
            </label>
            <input {...input} type={type} className="advanced-search__input" placeholder={placeholder} disabled={disabled}/>
            {touched && error &&
                <span className="advanced-search__field__error">
                    {lang[clang].validation[error]}
                </span>}
        </div>
    );
};

AdvancedSearchFormField.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(AdvancedSearchFormField);



// WEBPACK FOOTER //
// ./src/components/advanced-search/AdvancedSearchFormField.js